<template>
  <div>
    <section>
      <div v-if="changePwdFormVisible">
        <el-dialog title="修改密码" v-model="changePwdFormVisible" width=500px destroy-on-close draggable  show-close :close-on-click-modal="false">
          <el-form :model="changePwdForm" ref="dataForm" label-width="130px" :rules="addFormRules">
            <el-form-item label="登录账号名：" prop="Name">
              <el-col :span="19">
                <el-input v-model="changePwdForm.Name" readonly="readonly"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="设置新密码：" prop="NewPwd1">
              <el-col :span="19">
                <el-input v-model="changePwdForm.NewPwd1" type="password" auto-complete="off"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="确认新密码：" prop="NewPwd2">
              <el-col :span="19">
                <el-input v-model="changePwdForm.NewPwd2" type="password" auto-complete="off"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
          <template #footer>
            <div class="dialog-footer">
              <el-button @click="changePwdFormVisible = false">取消</el-button>
              <el-button type="primary" @click="hanldeSubmit">提交</el-button>
            </div>
          </template>
        </el-dialog>
      </div>
    </section>
  </div>
</template>

<script>
import {
  changeUserPassword
} from "@/api/setting/user"
export default {
  data() {
    const _this = this
    const pwdValidator1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (_this.changePwdForm.NewPwd2 != "") {
        this.$refs.dataForm.validateField("NewPwd2");
        callback();
      } else {
        callback();
      }
    }
    let pwdValidator2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== _this.changePwdForm.NewPwd1) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      changeLoading: false,
      changePwdFormVisible: false,
      userKey: "",
      isCurrent: false,
      changePwdForm: {
        Name: "",
        NewPwd1: "",
        NewPwd2: ""
      },
      addFormRules: {
        NewPwd1: [{
          validator: pwdValidator1,
          trigger: "change"
        }],
        NewPwd2: [{
          validator: pwdValidator2,
          trigger: "change"
        }]
      }
    }
  },
  methods: {
    showCurrentForm(userName) {
      this.changePwdForm.Name = userName
      this.changePwdFormVisible = true
      this.userKey = localStorage.getItem('X-UserKey');
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    showUserForm(userKey, userName) {
      this.userKey = userKey;
      this.changePwdForm.Name = userName
      this.changePwdFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    hanldeSubmit() {
      var _this = this;
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          this.$confirm("确认修改吗？", "提示", {}).then(() => {
            _this.changeLoading = true;
            changeUserPassword([this.userKey, this.changePwdForm.NewPwd1]).then(response => {
              _this.changeLoading = false
              if (response) {
                this.successMsg("操作成功");
                this.changePwdFormVisible = false
              }
            });
          });
        }
      });
    }
  }
};
</script>
<style>
.el-dialog {
  margin-top: 10px !important;
}
</style>
